import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NotificationsIndexComponent } from '$modules/personal/notifications/pages/notifications-index/notifications-index.component';
import { ShowNotificationComponent } from '$modules/personal/notifications/pages/show-notification/show-notification.component';

const routes: Routes = [
  {
    path: '',
    component: NotificationsIndexComponent,
  },
  {
    path: ':id',
    component: ShowNotificationComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NotificationsRoutingModule {}
